<template>
  <div v-if="isshow" class="radishdetail" style="width:400px;">
    <div class="close" @click="isshow = false">X</div>
    <radishScoreInner ref="radishScoreInner"></radishScoreInner>
  </div>
</template>
<script>
import radishScoreInner from './radishScoreInner'
export default {
  components: {
    radishScoreInner,
  },
  data() {
    return {
      isshow: false,
    }
  },
  methods: {
    async open(radishId, type, name) {
      this.isshow = true
      this.$nextTick(() => {
        this.$refs.radishScoreInner.open(radishId, type, name)
      })
    },
    domdrag() {
      let startX, startY, clientX, clientY
      let dom, zindex
      let draging = false
      document.addEventListener('mousedown', e => {
        if (typeof e.target.className !== 'object' && e.target.className.indexOf('radishdetail') !== -1) {
          e.preventDefault()
          dom = e.target
          zindex = app.root.dragindex++
          startX = dom.offsetLeft
          startY = dom.offsetTop
          clientX = e.clientXz
          clientY = e.clientY
          draging = true
        }
      })
      document.addEventListener('mousemove', e => {
        if (draging) {
          e.preventDefault()
          dom.style.left = e.clientX - clientX + startX + 'px'
          dom.style.top = e.clientY - clientY + startY + 'px'
        }
      })
      document.addEventListener('mouseup', e => {
        if (draging) draging = false
      })
    },
  },
  mounted() {
    this.domdrag()
  },
}
</script>
<style scoped>
.radishdetail {
  position: fixed;
  top: 60px;
  left: calc(50vw - 178px);
  z-index: 1600;
  width: 356px;
  padding: 16px 16px 0;
  background-color: #fff;
  border: 1px #c1c1c1 solid;
  border-radius: 5px;
  box-shadow: 0 0 8px 0 rgba(232, 237, 250, 0.6), 0 2px 4px 0 rgba(232, 237, 250, 0.5);
}

.radishdetail .close {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 20px;
  height: 20px;
  line-height: 20px;
  color: #fff;
  text-align: center;
  cursor: pointer;
  background-color: #e83939;
  border-radius: 50%;
}
</style>
